import { useAuth } from '@/contexts/AuthContext';
import { useCallback } from 'react';

type Modulo =
  | 'dashboard'
  | 'produtos'
  | 'fichas-tecnicas'
  | 'roteiros'
  | 'centro-trabalho'
  | 'responsaveis'
  | 'unidades-medida'
  | 'ordens'
  | 'apontamentos'
  | 'estoque'
  | 'custos'
  | 'romaneios'
  | 'qualidade';

const PERFIL_MODULOS: Record<string, string[]> = {
  BLOQUEADO: [],
  PRODUCAO: [
    'dashboard',
    'produtos',
    'fichas-tecnicas',
    'roteiros',
    'centro-trabalho',
    'responsaveis',
    'unidades-medida',
    'ordens',
    'apontamentos',
    'estoque',
    'custos',
  ],
  ROMANEIO: ['dashboard', 'produtos', 'romaneios', 'estoque'],
  INSPECAO: ['dashboard', 'produtos', 'qualidade', 'ordens'],
  COMPLETO: ['*'],
};

/**
 * Porta de src/composables/usePermissions.js (Vue).
 * Controla acesso a modulos do menu de industrializacao conforme o
 * perfil_industrializacao do usuario (BLOQUEADO/PRODUCAO/ROMANEIO/INSPECAO/COMPLETO).
 */
export function usePermissions() {
  const { isAdmin, perfilIndustrializacao } = useAuth();

  const temAcessoModulo = useCallback((modulo: Modulo | string): boolean => {
    if (isAdmin) return true;
    const modulosPermitidos = PERFIL_MODULOS[perfilIndustrializacao] || [];
    if (modulosPermitidos.includes('*')) return true;
    return modulosPermitidos.includes(modulo);
  }, [isAdmin, perfilIndustrializacao]);

  const isPerfilBloqueado = !isAdmin && perfilIndustrializacao === 'BLOQUEADO';

  const descricaoPerfil = (() => {
    const descricoes: Record<string, string> = {
      BLOQUEADO: 'Bloqueado',
      PRODUCAO: 'Produção',
      ROMANEIO: 'Romaneio',
      INSPECAO: 'Inspeção',
      COMPLETO: 'Acesso Completo',
    };
    return descricoes[perfilIndustrializacao] || 'Não definido';
  })();

  return { isAdmin, temAcessoModulo, isPerfilBloqueado, descricaoPerfil, perfilIndustrializacao };
}
